// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/stop-and-go.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const stopAndGo: Score = {
  slug: "stop-and-go",
  n: 23,
  title: "Stop and Go",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 84,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 60,
  highest: 67,
  hasLyrics: false,
  jasonNote: "This one is as much about the silences as the notes. A rest is not a rest for you \u2014 keep counting straight through it. Say the numbers out loud the first few times.",
  teaches: ["reading rests", "counting through silence", "starting a bar on a rest"],
  art: "/sight-reading/art/stop-and-go.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/stop-and-go.jpg",
  newForThisEdition: true,
  fillsGap: "Rests are never taught systematically in the printed book.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, rest: true, d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 64, pitch: "E4", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 65, pitch: "F4", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 6, hand: "rh", start: 23.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 7, hand: "rh", start: 24.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.5, dur: 0.5, rest: true, d: "eighth" },
    { bar: 7, hand: "rh", start: 25.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, rest: true, d: "eighth" },
    { bar: 7, hand: "rh", start: 26.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.5, dur: 0.5, rest: true, d: "eighth" },
    { bar: 7, hand: "rh", start: 27.0, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 7, hand: "rh", start: 27.5, dur: 0.5, rest: true, d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
  ],
};
